export const GameEvents = {
    RESIZE: "GameEvents.RESIZE",
    STATS_UPDATED: "GameEvents.STATS_UPDATED",
    STATE_CHANGED: "GameModel.STATE_CHANGED",
    LEVEL_LOADED: "GameModel.LEVEL_LOADED",
    RESTART_LEVEL: "GameModel.RESTART_LEVEL",
    AIM_CREATE: "AIM_CREATE",
    AIM_REMOVE: "AIM_REMOVE",
    AIM_HIDE: "AIM_HIDE",
    AIM_SET: "AIM_SET",
    AIM_UPDATE: "AIM_UPDATE",
    COINS_UPDATED: "COINS_UPDATED",
    HARD_BALANCE_UPDATED: "HARD_BALANCE_UPDATED",
    SELECTABLE_ITEM_CHANGED: "SELECTABLE_ITEM_CHANGED"
};
